import fetcher from 'api/fetcher';
import { parseISO } from 'date-fns';
import { ChangeHistoryType } from 'utils/constants/admin';

import {
    setIdAdminAction as setIdAdminActionForBanner,
    setLoadBannerAdminAction,
} from 'store/models/adminBannerAction';
import { setIdAdminAction, setLoadCampaignAdminAction } from 'store/models/adminCampaignAction';
import { EventType, setEvents, setShowModal, setType } from 'store/models/changeHistory';
import { AppThunkAction } from 'store/utils';

export const fetchChangeHistoryEvents = (
    type: ChangeHistoryType,
    campaignId: number,
    bannerId?: number
): AppThunkAction => {
    return async (dispatch) => {
        let url;
        if (bannerId && type === ChangeHistoryType.Banner) {
            url = `/api/v1/banner/change?bannerId=${bannerId}`;
            dispatch([setLoadBannerAdminAction(true), setIdAdminActionForBanner({ campaignId, bannerId })]);
        } else {
            url = `/api/v1/campaign/change?campaignId=${campaignId}`;
            dispatch([setLoadCampaignAdminAction(true), setIdAdminAction(campaignId)]);
        }
        return fetcher.get<unknown, EventType[]>(url).then((events) => {
            events.sort((a, b) => parseISO(a.changeTime).getTime() - parseISO(b.changeTime).getTime());
            dispatch([setShowModal(true), setEvents(events), setType(type)]);
        });
    };
};
